module.exports = __webpack_public_path__ + "static/media/history-grey.f26ebcf0.svg";